import { Subscription } from 'rxjs';

/* eslint-disable @typescript-eslint/no-explicit-any */
export namespace SubscriptionsActions {
  export class Add {
    static readonly type = '[SubscriptionsActions] Add';

    constructor(
      public component: any,
      public subscription: Subscription,
    ) {}
  }
  export class Destroy {
    static readonly type = '[SubscriptionsActions] Destroy';

    constructor(public component: any) {}
  }
}
